import '@mdi/font/css/materialdesignicons.css' 
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from '@/plugins/i18n';
import VueApexCharts from "vue-apexcharts";
import VueQRCodeComponent from 'vue-qrcode-component' 
// import * as firebase from "firebase";
 // Import component
import Loading from 'vue-loading-overlay';
 // Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import * as VueGoogleMaps from 'vue2-google-maps'

import './assets/css/main.css';
import Notifications from 'vue-notification'
import moment from 'moment'
import Breadcrumb from "@/components/core/Breadcrumb";
import LanguageSelection from "@/components/LanguageSelection.vue"
import FlagIcon from "vue-flag-icon"
import VueSignaturePad from 'vue-signature-pad';
import Flatten from '@flatten-js/core';
import { getGoogleMapsLoader } from './mixins/GoogleMapLoaderSingleton';
const COMPARISION_TOLERANCE = 0.00000000000001;
Flatten.Utils.setTolerance(COMPARISION_TOLERANCE);

Vue.use(VueSignaturePad);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY ,
    libraries: 'places',
  }
});



getGoogleMapsLoader({
  apiKey: process.env.VUE_APP_GOOGLE_MAP_KEY, 
  libraries: ["places", "map", "geometry"],
});

Vue.use(VueApexCharts);
Vue.use(Loading);
Vue.use(Notifications);
Vue.component('qrcode', VueQRCodeComponent);
Vue.component('breadcrumb', Breadcrumb)
Vue.component('LanguageSelection', LanguageSelection)
Vue.use(FlagIcon);



Vue.filter('formatDate', value => {
   if(!value) return 
    return moment(value).format('DD/MM/YYYY')
})
// const configOptions = {
//   apiKey: "AIzaSyC33tg6hg4PYHVP0Kr0lI--ppOpzSU0A0E",
//   authDomain: "dimitra-82a9a.firebaseapp.com",
//   databaseURL: "https://dimitra-82a9a-default-rtdb.firebaseio.com",
//   projectId: "dimitra-82a9a",
//   storageBucket: "dimitra-82a9a.appspot.com",
//   messagingSenderId: "464930559018",
//   appId: "1:464930559018:web:53bc5a447db7240c329f53",
//   measurementId: "G-QJN0PS6P30",
// };

// firebase.initializeApp(configOptions);
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || `https://sass-api-dev.dimitra.dev/api/admin`;
axios.defaults.headers.common['Content-Type'] = 'application/json';
var language = localStorage.getItem('LANGUAGE')
if( language == null){
  axios.defaults.headers.common['lang'] = 'en'
}else{
  axios.defaults.headers.common['lang'] = language
}
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.interceptors.request.use(function(config) {
  const token = store.getters.getAuthToken;
  if(token) {
    config.headers.common['oauth-token'] = `${token}`
  }
  return config;
}, function(err) {
  return Promise.reject(err);
});

axios.interceptors.response.use(function (response) {
  return response;
}, async function (error) {
    const token = store.getters.getAuthToken;
    if (axios.isAxiosError(error) && error.response?.status && error.response.status === 401 && token) {
      try{
        await store.dispatch('refreshToken');
        // console.log( error.response);
        const newTkn = store.getters.getAuthToken;
        error.response.config.headers['oauth-token'] = newTkn;
        return axios.request(error.response.config);
      }catch(err){
        // console.log('rf', err);
        await store.dispatch('logout');
        router.push('/login')
      }
    }

    if (axios.isAxiosError(error) && error.response?.status === 403 && token) {
      router.push({name: 'AdminDashboard'})
    }
    return Promise.reject(error);
});

Vue.component("apexchart", VueApexCharts);
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");